package com.neurobs.js.controller

import com.neurobs.ccab.CCABServer
import com.neurobs.errors.Result
import com.neurobs.js.dom.{AnchorLink, ElementFactory, Grid}
import com.neurobs.js.dom.ElementFactory.{PanelView, makeLink}
import com.neurobs.js.view.Container
import com.neurobs.js.dom.DOMViewElement._
import scalatags.JsDom.all._
import com.neurobs.js.dom.Grid._
import com.neurobs.react.{CardContentProvider, HtmlAdapter}
import com.neurobs.react.CardContentProvider.{Delegate, idCounter}
import slinky.core.facade.ReactElement

import scala.concurrent.Future

trait AdminPanelDelegate {
	/** Called when the panel creates a new panel */
	def newPanel(panel: AdminPanelController): Unit
	/** Called when the panel wants to close */
	def close(): Unit
}

trait AdminPanelController {
	var delegate: Option[AdminPanelDelegate] = None

	def didAppear() = {}

	def container: Container
}

abstract class BasicAdminPanelController(title: String, showRefresh: Boolean, showClose: Boolean) extends AdminPanelController {

	private val panel: PanelView = {
		val temp = new PanelView(title, showRefresh, fullWidth = true)
		if (showClose) {
			val closeLink: AnchorLink = makeLink(text = "Close")
			closeLink.setHandler(() => delegate.foreach(_.close()))
			temp.setRightCorner(closeLink.anchor)
		}
		temp.refresh.setHandler(refresh)
		temp
	}
	private var errorRow: Option[panel.grid.RowId] = None

	def setError(e: String): Unit = {
		errorRow.foreach(panel.grid.removeRow(_))
		errorRow =
			if (e.isEmpty) None
			else Some(panel.grid.addRow(div(b(style := "color: red;", e)).render))
	}

	val grid: Grid = panel.grid

	override def container = panel.container

	val refreshLink = panel.refresh

	def refresh(): Unit
}

class AdminPanelAdapter(panel: AdminPanelController) extends CardContentProvider {
	override def managed = false
	override def title: String = ""
	def canClose: Boolean = true
	def refreshFunction: Option[CCABServer => Future[Result[AnyRef]]] = None
	def content(d: Delegate, contentData: Option[AnyRef]): ReactElement = {
		val adminDelegate = new AdminPanelDelegate {
			override def newPanel(panel: AdminPanelController): Unit = {
				d.addCard(card = new AdminPanelAdapter(panel = panel), afterThis = true)
			}
			override def close(): Unit = d.closeThis()
		}
		panel.delegate = Some(adminDelegate)
		HtmlAdapter(element = ElementFactory.toElement(panel.container), onAdd = Some(() => panel.didAppear()))
	}
}